import Button from '@mui/material/Button'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const MetaFilterStyledPopover = styled(Popover)`
  .MuiPopover-paper {
    padding: ${componentSizes.smDistance};
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
`

export const MetaFilterPopoverItem = styled('div')`
  width: 420px;
  min-height: 64px;
  background-color: ${colors.commonGrey};
  border-radius: 4px;
  border: 1px solid ${({ $selected }: { $selected: boolean }) => ($selected ? colors.primaryDark : 'transparent')};

  & + & {
    margin-top: 15px;
  }
`

export const MetaFilterPopoverItemContent = styled('div')`
  display: flex;
  align-items: center;
  min-height: 64px;
  justify-content: space-between;
  padding: 8px 12px;
`

export const MetaFilterPopoverItemContentInner = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`

export const MetaFilterPopoverSubmitButton = styled(Button)`
  margin-top: 15px;
  padding: 14px 16px;
`

export const MetaFilterPopoverCloseButton = styled(Button)`
  margin-bottom: 15px;
  padding: 0;
  &:hover {
    background: transparent;
  }
`

export const MetaFilterTypography = styled(Typography)`
  font-weight: 600;
`

export const MetaFilterDefaultTypography = styled(MetaFilterTypography)`
  cursor: pointer;
`
